module.exports = __webpack_public_path__ + "img/green.94e87f1e.jpg";